export class WebSimulacao {
    idSimulacao: number
    cpf: string
    email: string
    nome: string
    dtNascimento: Date
    tipoSimulacao: number
    valorAporte: number
    rentabilidade: number
    anosCtb: number
    anosRec: number
    valorCtb: number
    valorSimulacao: number
    dtSimulacao: Date
}